import { BaseDataBind } from "./base";

/**
 * Data bind type for <input type="checkbox" />.
 */
export class CheckboxDataBind extends BaseDataBind
{
    public attributeName = 'data-bind-checkbox';
    public selector = '[data-bind-checkbox]';
    public eventNames = ['change'];

    protected setElementValue(element: Element, value: any)
    {
        if (typeof value === 'string')
        {
            try
            {
                value = JSON.parse(value as string);
            }
            catch (error)
            {
                value = false;
            }
        }
        else if (typeof value === 'number')
        {
            value = value ? true : false;
        }

        (element as HTMLInputElement).checked = value;
    }

    protected getElementValue(element: Element): any
    {
        return (element as HTMLInputElement).checked;
    }
}
